import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isExtraPage } from '../utils/extraPages';
import { useAccountOverview } from '../context/AccountOverviewContext';
import { selectUtilityLoading, selectActiveClients } from '../redux/utilitySlice';
/**
 * usePageAccessControl
 *
 * Centralized hook to manage page access and redirection.
 * Ensures that "Extra Pages" have context state and "Standard Pages" have URL params.
 */
export const usePageAccessControl = (selectedId) => {
    const location = useLocation();
    const navigate = useNavigate();
    const utilityLoading = useSelector(selectUtilityLoading);
    const clients = useSelector(selectActiveClients);
    const { selectedClientId: contextClientId } = useAccountOverview();
    const pathname = location.pathname;
    const isExtra = isExtraPage(pathname);
    const clientOptions = Array.isArray(clients) ? clients : (clients?.data || []);
    useEffect(() => {
        // Only run check if utility loading has finished and we have clients
        if (!utilityLoading && clientOptions.length > 0) {
            if (isExtra) {
                // ✅ Extra Page Validation (Context API based)
                if (!selectedId && !contextClientId) {
                    console.warn(`[AccessControl] Missing context for extra page: ${pathname}. Waiting for auto-selection...`);
                    // navigate(ROUTES.accountSummary.path); // Removed to allow useClientSelection to auto-select
                }
            }
            else {
                // ✅ Standard Page Validation (URL based)
                // We only enforce this for pages that ARE expected to have a clientId
                // Some pages like "Account Summary" list itself don't need it.
                // You can add more granular logic here if needed.
                const queryParams = new URLSearchParams(location.search);
                const urlId = queryParams.get('clientId');
                // If a page is meant to be client-specific but lacks a URL param, handle it here.
                // For now, we only enforce this for pages that call this hook.
            }
        }
    }, [pathname, isExtra, selectedId, contextClientId, utilityLoading, clientOptions.length, navigate, location.search]);
    return { isExtra };
};
